<template>
  <div class="animated fadeIn">
    <h4 class="page-title">VRMS - Vehicle List</h4>
    <hr >
    <b-row>
      <b-col>
        <b-form @submit.prevent="handleSearch">
          <b-row class="mb-3">
            <b-col md="2" :class="{'mb-3': $mq === 'sm'}">
              <b-form-input
                v-model="licensePlate"
                placeholder="License Plate"
                class="mr-2" />
            </b-col>
            <b-col md="2" :class="{'mb-3': $mq === 'sm'}">
              <b-form-input
                v-model="make"
                placeholder="Make"
                class="mr-2" />
            </b-col>
            <b-col md="2" :class="{'mb-3': $mq === 'sm'}">
              <b-form-input
                v-model="model"
                placeholder="Model"
                class="mr-2" />
            </b-col>
            <b-col md="1">
              <b-btn variant="warning" @click="handleAdvanceFilterVisibility">
                <i class="fa fa-filter" />
              </b-btn>
            </b-col>
            <b-col md="3" :class="{'mb-3': $mq === 'sm'}">
              <div class="d-flex">
                <b-btn
                  :disabled="!licensePlate && !make && !model"
                  variant="warning"
                  :size="$mq === 'sm' ? 'small' : ''"
                  type="submit">
                  Search
                </b-btn>
                <b-btn
                  class="ml-3"
                  variant="secondary"
                  :size="$mq === 'sm' ? 'small' : ''"
                  @click="handleReset">
                  Reset
                </b-btn>
              </div>
            </b-col>
            <b-col>
              <b-btn
                v-if="$hasRole(serviceModule, 'Admin')"
                :disabled="!items.length || isDownloading"
                class="ml-auto"
                :class="{'float-right': $mq !== 'sm'}"
                :size="$mq === 'sm' ? 'small' : ''"
                variant="success"
                @click="handleDownload">
                <i class="icon-cloud-download" />
                Download
              </b-btn>
            </b-col>
          </b-row>
        </b-form>
        <div 
          v-if="isFetching" 
          style="margin: 0 auto; width: 10px;">
          <div class="loader-dark-blue medium mb-5 mt-5"/>
        </div>
        <b-alert
          :show="!items.length && !isFetching"
          variant="danger">
          No Results
        </b-alert>
        <b-table
          v-if="items.length && !isFetching"
          :fields="fields"
          :items="items"
          responsive
          hover
          striped
          @row-clicked="handleRowClicked">
          <template v-slot:cell(timeDue)="{ item }">
            {{ item.timeDue | date('DD/MM/YYYY') }}
          </template>
          <template v-slot:cell(daysDifference)="{ item }">
            {{ item.daysDifference ? `${item.daysDifference} days` : 'N.A' }}
          </template>
          <template v-slot:cell(action)="row">
            <b-btn
              v-b-tooltip.hover
              v-if="$hasRole('VRMS', 'admin')"
              variant="warning"
              size="sm"
              title="Edit record"
              @click="edit(row.item)">
              <i class="fa fa-pencil-square-o"/>
            </b-btn>
            <b-btn
              v-b-tooltip.hover
              class="ml-2"
              variant="info"
              size="sm"
              title="View record"
              @click="view(row.item)">
              <i class="fa fa-eye"/>
            </b-btn>
          </template>
        </b-table>
        <!-- <b-pagination
          v-show="items.length > 10 && !isFetching"
          :total-rows="items.length"
          :per-page="10"
          v-model="currentPage" /> -->
      </b-col>
    </b-row>

    <!-- View modal -->
    <VehicleRecordModal 
      v-if="viewModalVisibility" 
      :item="selectedItem" />

    <AdvanceFilter
      v-if="advanceFilterVisibility"
      :zone-list="zones"
      :station-list="stations"
      @search="handleFilterApply" />
  </div>
</template>
<script>
import { toastr } from '@/services'
import startCase from 'lodash/startCase'
import { mapState, mapActions } from 'vuex'
import VehicleRecordModal from './VehicleRecordModal'
import AdvanceFilter from './AdvanceFilter'

export default {
  name: 'VehicleList',
  components: {
    VehicleRecordModal,
    AdvanceFilter
  },
  data () {
    return {
      serviceModule: process.env.VUE_APP_MODE === 'production' ? 'CCPL - VMTS v2' : 'OPS - VMTS REVAMP',
      advanceFilterVisibility: false,
      viewModalVisibility: false,
      selectedItem: undefined,
      currentPage: 1,
      licensePlate: undefined,
      make: undefined,
      model: undefined,
      isDownloading: false,
      // fields: [
      //   'vehicleNumber',
      //   'make',
      //   'model',
      //   'status',
      //   'area',
      //   'station',
      //   'mileageDifference',
      //   'daysDifference',
      //   'timeDue'
      // ]
    }
  },
  computed: {
    // ...mapState('vrms', {
    //   items: state => state.vehicleList,
    //   isFetching: state => state.isFetching
    // }),
    ...mapState('vmts', {
      items: state => state.vehicles,
      isFetching: state => state.isFetching,
      fields: state => state.fields,
      zones: state => state.zones,
      stations: state => state.stations
    })
  },
  created () {
    // this.searchValue = this.$route.query.q ? this.$route.query.q : undefined
    this.fetchZones()
    this.fetchStations()
    if (Object.entries(this.$route.query).length) {
      this.licensePlate = this.$route.query.licensePlate || undefined
      this.make = this.$route.query.make || undefined
      this.model = this.$route.query.model || undefined
      this.handleSearch()
    } else {
      this.getVehicleList()
    }
  },
  methods: {
    ...mapActions('vmts', [
      'getVehicleList',
      'fetchZones',
      'fetchStations'
    ]),
    handleSearch (params) {
      let payload = {
        licensePlate: this.licensePlate,
        make: this.make,
        model: this.model
      }
      payload = { ...payload, ...params }
      // remove empty value
      Object.keys(payload).forEach((key) => (payload[key] === null || payload[key] === '') && delete payload[key])
      this.getVehicleList(payload)
    },
    handleFilterApply(params) {
      setTimeout(() => {
        this.$bvModal.hide('advance-filter-modal')
      }, 100)
      this.handleSearch(params)
    },
    handleDownload () {
      const replacer = (key, value) => value === null ? '' : value // specify how you want to 
      let arr = JSON.parse(JSON.stringify(this.items)).map((item) => ({
        ...item,
        timeDue: this.$options.filters.date(item.timeDue)
      }))
      arr = arr.map((item) => {
        const { rowVarian, ...rest } = item
        return rest
      })
      const headers = Object.keys(arr[0]).map((k) => ({ label: startCase(k), key: k }))
      let csvData = arr.map(row => headers.map(fieldName => JSON.stringify(row[fieldName.key], replacer)).join(','))
      csvData.unshift(headers.map(h => h.label).join(','))
      csvData = csvData.join('\r\n')
      const filename = `Vehicle_List_${this.$options.filters.date(new Date(), 'YYYY-MM-DD')}.csv`
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename)
      } else {
        const link = document.createElement('a')
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', filename)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    },
    // handleDownload () {
    //   this.isDownloading = true
    //   const payload = {
    //     isDownload: true,
    //     licensePlate: this.searchValue
    //   }
    //   payload.licensePlate = this.searchValue ? payload.licensePlate.toUpperCase() : undefined
    //   this.$store.dispatch('vrms/download', payload).then(
    //     ({ data, headers, status }) => {
    //       if (status === 404) {
    //         this.isDownloading = false
    //         toastr.serverError()
    //       } else {
    //         const contentDisposition = headers['content-disposition']
    //         const filename = contentDisposition.replace('attachment; filename=', '')
    //         const a = document.createElement('a')
    //         document.body.appendChild(a)
    //         a.style = 'display: none'
    //         const blob = new Blob([data], {type : 'text/csv'})
    //         const url = window.URL.createObjectURL(blob)
    //         a.href = url
    //         a.download = filename
    //         a.click()
    //         window.URL.revokeObjectURL(url)
    //         document.body.removeChild(a)          
    //         this.isDownloading = false
    //       }
    //     }
    //   ).catch((err) => {
    //     console.log(err)
    //     toastr.serverError()
    //   })
    // },
    handleReset () {
      this.licensePlate = undefined
      this.make = undefined
      this.model = undefined
      this.getVehicleList()
    },
    edit (item) {
      this.$router.push({ name: 'VehicleRecord', query: { licensePlate: item.licensePlate, q: this.searchValue } })
    },
    view (item) {
      this.viewModalVisibility = true
      this.selectedItem = item
      setTimeout(() => {
        this.$bvModal.show('view-record-modal')
      }, 200)
    },
    handleRowClicked (item) {
      this.$router.push({ name: 'VehicleMonitoring', query: { licensePlate: item.vehicleNumber } })
    },
    handleAdvanceFilterVisibility() {
      this.advanceFilterVisibility = true
      setTimeout(() => {
        this.$bvModal.show('advance-filter-modal')
      }, 100)
    }
  }
}
</script>